module.exports = __webpack_public_path__ + "static/light-gradient-2-18a158029ad61eb977b63b46c688310e.png";